import './navbar.css';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, Avatar, Layout, Dropdown } from 'antd';
import { faCalendarDays, faChartColumn, faChevronDown, faFileInvoice, faHouse, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from "../../assets/img/wc-logo-big.png"
import { IncidentBell } from './incidentBell';

function getInitials(name) {
    if (!name || typeof name !== 'string') return '';
    const words = name.trim().split(/\s+/);
    if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
}

const UserMenu = ({ visible, setVisible, customerDetail, handelLogout }) => {
    const menu = (
        <Menu id="profile-menu" style={{ width: '290px', borderRadius: '0', border: '1px solid #cbd6e2', marginTop: '-2px' }}>
            <div style={{ padding: '10px 8px', display: 'flex', alignItems: 'start', gap: '15px' }}>
                <div className='user-avatar'>
                    {customerDetail?.metadata?.logolink
                        ? <div style={{
                            height: 40, minWidth: 40, maxWidth: 80,
                            background: '#f5f8fa', borderRadius: 6, border: '1px solid #e2e8f0',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            padding: '3px 6px', overflow: 'hidden',
                          }}>
                            <img
                                src={customerDetail.metadata.logolink}
                                alt="logo"
                                style={{ maxHeight: 32, maxWidth: 70, width: 'auto', objectFit: 'contain' }}
                            />
                          </div>
                        : <Avatar size={40}>{getInitials(customerDetail?.customername)}</Avatar>
                    }
                </div>
                <div>
                    <div style={{ fontSize: '14px', fontWeight: '600' }}>{customerDetail?.customername}</div>
                    <div className='text' style={{ margin: 0, color: '#7c98b6' }}>{customerDetail?.metadata?.customeremail}</div>
                </div>
            </div>

            <Menu.Divider />

            <Menu.Item key="2" onClick={() => { window.open("mailto:safyan@intraguard.co.uk") }}>Report a problem</Menu.Item>
            <Menu.Item key="3" onClick={handelLogout}>Logout</Menu.Item>
        </Menu>
    );

    return (
        <Dropdown menu={{ items: [] }} dropdownRender={() => menu} open={visible} placement="bottomLeft" onOpenChange={setVisible}>
            <div className='user-avatar' style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                {customerDetail?.metadata?.logolink
                    ? <div style={{
                        height: 32, minWidth: 32, maxWidth: 100,
                        background: '#fff', borderRadius: 6,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        padding: '3px 8px', overflow: 'hidden',
                      }}>
                        <img
                            src={customerDetail.metadata.logolink}
                            alt="logo"
                            style={{ maxHeight: 26, maxWidth: 90, width: 'auto', objectFit: 'contain' }}
                        />
                      </div>
                    : <Avatar size={"large"}>{getInitials(customerDetail?.customername)}</Avatar>
                }
                <span style={{ marginLeft: '8px' }}>{customerDetail?.customername}</span>
                <FontAwesomeIcon icon={faChevronDown} style={{ marginLeft: '8px' }} />
            </div>
        </Dropdown>
    );
};


// the portal's sections - top menu on desktop, bottom tab bar on phones.
// hidden: kept (page and route still work) but not in the menu for now
const NAV = [
    { key: 'today', label: 'Dashboard', icon: faHouse, path: '/customer' },
    { key: 'roster', label: 'Schedule', icon: faCalendarDays, path: '/customer/schedule' },
    { key: 'reports', label: 'Reports', icon: faChartColumn, path: '/customer/service-report', hidden: true },
    { key: 'incidents', label: 'Incidents', icon: faTriangleExclamation, path: '/customer/incidents' },
    { key: 'invoices', label: 'Invoices', icon: faFileInvoice, path: '/customer/invoices' },
];

// Schedules & Activity (/customer/reports) and duty requests sit under Reports / Roster
const activeNavKey = (pathname) => {
    if (pathname.startsWith('/customer/schedule') || pathname.startsWith('/customer/roster') || pathname.startsWith('/customer/duty-requests')) return 'roster';
    if (pathname.startsWith('/customer/service-report') || pathname.startsWith('/customer/reports')) return 'reports';
    if (pathname.startsWith('/customer/incidents')) return 'incidents';
    if (pathname.startsWith('/customer/invoices')) return 'invoices';
    return 'today';
};

export function Navbar({ customerDetail }) {
    const handelLogout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location = "/";
    };

    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const active = activeNavKey(pathname);

    return (
        <Layout style={{ marginBottom: '50px' }}>
            <Menu mode="horizontal" theme="dark" className='top-menu-layout' triggerSubMenuAction="click" selectedKeys={[active]} disabledOverflow>

                <Menu.Item onClick={() => navigate("/customer")}>
                    <img src={logo} style={{ width: '30px', height:'30px' }} className='menu-icon' />
                </Menu.Item>

                {NAV.filter((item) => !item.hidden).map((item) => (
                    <Menu.Item key={item.key} className="nav-section" onClick={() => navigate(item.path)}>
                        {item.label}
                    </Menu.Item>
                ))}

                <Menu.Item className='search' key="search" style={{ margin: 'auto', background: 'none', backgroundColor: 'transparent' }} />

                <Menu.Item key="incident-bell" className="nav-bell-menu-item">
                    <IncidentBell />
                </Menu.Item>

                <Menu.Item>
                    <div className='vertical-separator' />
                </Menu.Item>

                <Menu.Item>
                    <UserMenu visible={visible} handelLogout={handelLogout} customerDetail={customerDetail} setVisible={setVisible} />
                </Menu.Item>

            </Menu>

            <nav className="bottom-nav" aria-label="Sections">
                {NAV.filter((item) => !item.hidden).map((item) => (
                    <button
                        key={item.key}
                        type="button"
                        className={active === item.key ? 'bottom-nav-item active' : 'bottom-nav-item'}
                        onClick={() => navigate(item.path)}
                        aria-current={active === item.key ? 'page' : undefined}
                    >
                        <FontAwesomeIcon icon={item.icon} />
                        <span>{item.label}</span>
                    </button>
                ))}
            </nav>
        </Layout>
    );
}
